import { Button, Result, Spin } from 'antd';
import styled from 'styled-components';

import useAuthCallback from '../hooks/useAuthCallback';
import type { AppType, IOAuth2Config } from '../utils/types';
import { setToken } from '../utils/setToken';
import { axiosInt } from '../../utils/axios';

interface IAuthCallbackProps {
  config: IOAuth2Config;
  dashboardPath: string;
  loginPath: string;
  appType: AppType;
  noAuthorizedRedirectUrl: string;
  onError?: (error: unknown) => void;
}

const AuthCallback: React.FC<IAuthCallbackProps> = ({
  config,
  dashboardPath,
  loginPath,
  appType,
  noAuthorizedRedirectUrl,
  onError,
}) => {
  const { authState, errorMessage, handleTryAgain } = useAuthCallback({
    config,
    axiosInstance: axiosInt,
    setToken: setToken,
    dashboardPath,
    loginPath,
    appType,
    noAuthorizedRedirectUrl,
    onError,
  });

  if (authState === 'loading') {
    return (
      <WrapperDiv>
        <Spin tip="Finalizing login..." size="large" />
      </WrapperDiv>
    );
  }

  if (authState === 'success') {
    return (
      <WrapperDiv>
        <Spin tip="Redirecting..." size="large" />
      </WrapperDiv>
    );
  }

  if (authState === 'error') {
    return (
      <WrapperDiv>
        <Result
          status="error"
          title="Login error"
          subTitle={errorMessage}
          extra={[
            <Button type="primary" key="tryAgain" onClick={handleTryAgain}>
              Try again
            </Button>,
          ]}
        />
      </WrapperDiv>
    );
  }

  return null;
};

export default AuthCallback;

const WrapperDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 90vh;
  background-color: #f5f7f9;
  width: 100%;
`;
